


































































import * as R from 'ramda';
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import DeleteCriticalDataDialog from '@/components/molecules/DeleteCriticalDataDialog.vue';

@Component({
  components: {
    DeleteCriticalDataDialog,
  },
})
export default class DeleteUserDataDialog extends Vue {
  @Prop()
  private loginName!: string;

  private confirmUserDataDelete: boolean = false;
  private confirmUserDataReplace: boolean = false;
  private isTheInputEqualToLoginName: boolean = false;

  private validateIfEqualToLoginName(input: string) {
    this.isTheInputEqualToLoginName = R.equals(this.loginName, input);
  }

  private get isDeleteOperationConfirmed() {
    return (
      this.confirmUserDataDelete &&
      this.confirmUserDataReplace &&
      this.isTheInputEqualToLoginName
    );
  }

  @Emit('pressed-delete-btn')
  private pressedDeleteBtn() {
    return this.loginName;
  }

  @Emit('pressed-cancel-btn')
  private pressedCancelBtn() {}
}
